module.exports = "https://coursera_assets.s3.amazonaws.com/images/a9f8b9c17a1b3a4d0dfb4b55685da8d3.png";